
import { int } from "@goodgamestudios/math-utilities";

import { HotspotAnimationVO } from "./animationvo/HotspotAnimationVO";

import { getLogger } from "@goodgamestudios/logger";

import { IAniHelper } from "./IAniHelper";

import DisplayObject = createjs.DisplayObject;
import MovieClip = createjs.MovieClip;
import Container = createjs.Container;

const logger = getLogger("HotspotAniHelperController");

export class HotspotAniHelperController {
    private _hotspotAnimations: HotspotAniHelper[];

    constructor() {
        this._hotspotAnimations = [];
    }

    public showHotspotAnimation(playerContainer: MovieClip, animationContainer: Container, tableScreen: DisplayObject): void {
        // configure animation vo
        var vo: HotspotAnimationVO = new HotspotAnimationVO(playerContainer, animationContainer, tableScreen);
        vo.animationCompleteCallback = this.bindFunction(this.onAnimationComplete);

        // create animation helper
        var animation: IAniHelper = new HotspotAniHelper();

        // store animation
        this._hotspotAnimations.push(animation as HotspotAniHelper);

        // execute animation
        animation.doAnimation(vo);
    }

    private onAnimationComplete(finishedAni: IAniHelper): void {
        var i: number = 0;
        var len: number = int(this._hotspotAnimations.length);
        var tempAni: HotspotAniHelper;
        for (i = 0; i < len; ++i) {
            try {
                tempAni = this._hotspotAnimations[i];
            }
            catch (error) { //RangeError
                logger.error("onAnimationComplete() -> RANGE ERROR, i: " + this._hotspotAnimations, this._hotspotAnimations.length);
                return;
            }

            if (tempAni == finishedAni) {
                finishedAni.kill();
                finishedAni = null;
                this._hotspotAnimations.splice(i, 1);
                break;
            }
        }
    }

    public kill(): void {
        var i: number = 0;
        var len: number = int(this._hotspotAnimations.length);
        var tempAni: HotspotAniHelper;
        for (i = 0; i < len; ++i) {
            tempAni = this._hotspotAnimations[i];
            tempAni.kill();
            tempAni = null;
        }

        // re-initialize
        this._hotspotAnimations = [];
    }
}
import { HotspotAniHelper } from "./HotspotAniHelper";
